module.exports = __webpack_public_path__ + "img/mezzanine_overview_icon01.5a62adaa.svg";